import * as React from "react";
import styled from "@emotion/styled";
import Modal from "@/components/molecules/Modal";
import MediaQueryContext, { initMediaQueryStore } from "@/contexts/MediaQuery";
import { useTheme } from "@/hooks/useTheme";
import Button from "@/components/atoms/Button";
import breakpoint from "@/utils/breakpoint";

type RoadConnectingInfoProps = Record<string, any> & React.HTMLAttributes<HTMLDivElement>;

const ModalBody = styled(Modal.Body)`
  border: none;
  overflow: hidden;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background: #ffffff;
  }
  ::-webkit-scrollbar-thumb {
    background: #cccccc;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const BodyWrapper = styled.div``;

const StyledText = styled.div`
  padding: 40px 60px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  ${breakpoint.lessThan("sm")`
  padding: 0;
  padding-top: 10px;
  padding-bottom: 40px;
`}
`;

const ModalFooter = styled(Modal.Footer)`
  text-align: center;
`;

const CloseCenterButton = styled(Button)`
  width: 170px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #333333;
  border-radius: 24px;
  opacity: 1;
  font-size: 14px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 20px;
  ${breakpoint.lessThan("sm")`
    padding: 5 10px;
  `}
`;

const RoadConnectingStatus = ({ open, onCloseClick }: RoadConnectingInfoProps) => {
  const { isNewTheme } = useTheme();
  const { current: range } = React.useContext(MediaQueryContext) || initMediaQueryStore("md");

  const cssOverrideModalStyle = () => {
    const cssOverrideModalStyle = {
      overflow: "hidden",
      padding: "10px 10px",
      borderRadius: "10px",
      margin: "0",
    };
    if (isNewTheme) {
      if (range === "sm") {
        cssOverrideModalStyle.padding = "10px 20px 20px 20px";
        cssOverrideModalStyle.margin = "60px 15px 0 15px";
      }
    }

    return cssOverrideModalStyle;
  };

  const handleClose = () => {
    onCloseClick();
  };

  return (
    <>
      {open && (
        <Modal
          top={range === "sm" ? "10%" : "30%"}
          open={open}
          width="680px"
          height="204px"
          style={cssOverrideModalStyle()}
          flex
        >
          <ModalBody>
            <BodyWrapper>
              <StyledText>
                敷地がいくつ道路に接しているかを選択してください。
                接する道路がふたつの場合には、二方（正面と裏面）と角地（道路が交差）があります。
              </StyledText>
            </BodyWrapper>
          </ModalBody>
          <ModalFooter>
            <CloseCenterButton onClick={handleClose} color="danger">
              閉じる
            </CloseCenterButton>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default RoadConnectingStatus;
